import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ onToggle, activeNavItem, onNavItemChange }) => {
  const [expanded, setExpanded] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Helper function to get the current school from URL or use default
  const getSchoolFromUrl = () => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get('school') || 'UIUC';
  };
  
  useEffect(() => {
    if (onToggle) {
      onToggle(expanded);
    }
  }, [expanded, onToggle]);

  const handleNavClick = (itemName) => {
    if (onNavItemChange) {
      onNavItemChange(itemName);
    }
    
    // Get the school parameter
    const school = getSchoolFromUrl();
    
    // Navigate to appropriate route based on nav item, preserving school parameter
    switch(itemName) {
      case 'Evidence Library':
        navigate(`/evidence-library?school=${school}`);
        break;
      case 'Accreditation Bank':
        navigate(`/?school=${school}`);
        break;
      case 'Student Outcomes':
        // This is handled by the parent component, but pass along the school
        // If there's a handler, it should use the school parameter
        navigate(`/student-outcomes?school=${school}`);
        break;
      case 'Teacher Evaluation':
        // Navigate to teacher evaluation page
        navigate(`/teacher-evaluation?school=${school}`);
        break;
      case 'Programs Assessment':
        navigate(`/programs-assessment?school=${school}`);
        break;
      case 'Courses Assessment':
        navigate(`/courses-assessment?school=${school}`);
        break;
      default:
        break;
    }
  };

  const toggleSidebar = () => {
    setExpanded(!expanded);
  };
  
  const handleLogoClick = () => {
    // Get the school parameter
    const school = getSchoolFromUrl();
    
    // Update the active nav item to Accreditation Bank since we're going to the home page
    if (onNavItemChange) {
      onNavItemChange('Accreditation Bank');
    }
    
    // Navigate to home and refresh the page
    window.location.href = `/?school=${school}`;
  };

  return (
    <div className={`sidebar ${expanded ? 'expanded' : 'collapsed'}`}>
      <div className="logo-container">
        <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img src="/AristAI-logo-2.svg" alt="AristAI Icon" className="logo-icon" />
          <img src="/AristAI-logo-text.svg" alt="AristAI" className={`logo-text ${!expanded ? 'hidden' : ''}`} />
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <ul>
        <li 
            className={activeNavItem === 'Accreditation Bank' ? 'active' : ''}
            onClick={() => handleNavClick('Accreditation Bank')}
          >
            <img src="/left-side-icon-2.svg" alt="Accreditation Bank Icon" className="nav-icon" />
            <span className="nav-text">Accreditation Bank</span>
          </li>
          <li 
            className={activeNavItem === 'Evidence Library' ? 'active' : ''}
            onClick={() => handleNavClick('Evidence Library')}
          >
            <img src="/left-side-icon-1.svg" alt="Evidence Library Icon" className="nav-icon" />
            <span className="nav-text">Evidence Library</span>
          </li>
          
          <li 
            className={activeNavItem === 'Student Outcomes' ? 'active' : ''}
            onClick={() => handleNavClick('Student Outcomes')}
          >
            <img src="/left-side-icon-3.svg" alt="Student Outcomes Icon" className="nav-icon" />
            <span className="nav-text">Student Outcomes</span>
          </li>

          <li 
            className={`teacher-evaluation-hidden ${activeNavItem === 'Teacher Evaluation' ? 'active' : ''}`}
            onClick={() => handleNavClick('Teacher Evaluation')}
          >
            <img src="/id-card.svg" alt="Teacher Evaluation Icon" className="nav-icon" />
            <span className="nav-text">Teacher Evaluation</span>
          </li>
        
          {/* <li 
            className={activeNavItem === 'Courses Assessment' ? 'active' : ''}
          >
            <img src="/left-side-icon-4.svg" alt="Courses Assessment" className="nav-icon" />
            <span className="nav-text">History</span>
          </li> */}
        </ul>
      </nav>
      
    </div>
  );
};

export default Sidebar;